import styled from 'styled-components'

export const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
`
